import { defineFcm } from '../shared/factory';

export const FCM_DM_SELF_SERVICE_ENABLED = defineFcm('dm_self_service_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-chameleon',
		scope: ['corgi-front-end', 'corgi-middle-end'],
		supportedGroups: { global: true },
		context: 'DM self-service response flow',
		description:
			'Kill switch for the DM self-service tokenized response flow: the decisionMakerResponseContext query, the generateDecisionMakerResponseDraft and submitDecisionMakerResponseForReview mutations, and the response page',
		import: false,
	});
